import replaceInvertedQuotes from 'components/Dashboard/utilities/replaceInvertedQuotes';

const ChangeKeywordsCategory = (keywords) => {
  let trimmedKeywords = [];
  keywords?.forEach((item) => {
    const cleanedItem = replaceInvertedQuotes(item);
    if (!cleanedItem.includes('"')) {
      trimmedKeywords.push(cleanedItem.trim());
    } else {
      trimmedKeywords.push(cleanedItem);
    }
  });
  return trimmedKeywords
    .map((item) => {
      // Escape double quotes inside the keyword
      const escaped = item.replace(/"/g, '""');
      // Wrap in double quotes if contains space or double quote
      if (escaped.includes(' ') || escaped.includes('"')) {
        return `"${escaped}"`;
      }
      return escaped;
    })
    .join(',');
};

export default ChangeKeywordsCategory;
